/* Collection filters and sorting: live updates through the Section Rendering API, history kept in sync.
   Without JS the form submits and the links navigate, so everything still works. */
(function () {
  'use strict';

  class HeFacets extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.form = this.querySelector('[data-facet-form]');
      this.panel = this.querySelector('[data-facets-panel]');
      this.onKey = this.onKey.bind(this);
      this.onPop = this.onPop.bind(this);
      this.queue = window.HE.debounce(this.submitForm.bind(this), 350);

      this.addEventListener('change', (e) => {
        if (e.target.form === this.form || e.target.matches('[data-sort]')) this.queue();
      });
      this.addEventListener('input', (e) => { if (e.target.type === 'number') this.queue(); });
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submitForm(); });
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link) { e.preventDefault(); this.render(link.href, true); return; }
        if (e.target.closest('[data-facets-open]')) this.openPanel(e.target.closest('[data-facets-open]'));
        else if (e.target.closest('[data-facets-close]')) this.closePanel();
      });
      // the fit finder toggles are links (so they work without JS) announced as toggle buttons: Space must work too
      this.addEventListener('keydown', (e) => {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        const toggle = e.target.closest('a[role="button"]');
        if (!toggle || !this.contains(toggle)) return;
        e.preventDefault();
        toggle.click();
      });
      window.addEventListener('popstate', this.onPop);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); this.closePanel(); }

    submitForm() {
      if (!this.form) return;
      const params = new URLSearchParams();
      new FormData(this.form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
      const url = this.dataset.url + (params.toString() ? '?' + params.toString() : '');
      this.render(url, true);
    }
    onPop() { this.render(location.href, false); }

    render(url, push) {
      const u = new URL(url, location.origin);
      u.searchParams.delete('page');
      const fetchUrl = new URL(u); fetchUrl.searchParams.set('section_id', this.section);
      const req = (this.req = (this.req || 0) + 1);
      this.setAttribute('aria-busy', 'true');
      fetch(fetchUrl.toString())
        .then((r) => r.text())
        .then((html) => {
          if (req !== this.req) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const focusId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : null;
          const openIds = Array.from(this.querySelectorAll('details.facet[open]')).map((d) => d.id);
          this.querySelectorAll('[data-swap]').forEach((el) => {
            const fresh = doc.querySelector('[data-swap="' + el.dataset.swap + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          // keep the groups the shopper had open, and focus where it was
          openIds.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
          const freshBtn = doc.querySelector('[data-facets-open]'), btn = this.querySelector('[data-facets-open]');
          if (freshBtn && btn) btn.innerHTML = freshBtn.innerHTML;
          // the sort select sits outside the swapped regions; keep it in step (back/forward, filter links)
          const freshSort = doc.querySelector('[data-sort]'), sort = this.querySelector('[data-sort]');
          if (freshSort && sort) sort.value = freshSort.value;
          if (focusId) { const f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
          if (push) history.pushState({ facets: true }, '', u.pathname + u.search);
        })
        .catch(() => { location.href = u.toString(); })
        .finally(() => this.removeAttribute('aria-busy'));
    }

    /* mobile filter panel */
    openPanel(opener) {
      if (!this.panel || this.panel.classList.contains('is-open')) return;
      this.opener = opener;
      this.panel.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKey);
      window.HE.overlayChanged(1);
      const first = this.panel.querySelector('.facets__head button');
      if (first) first.focus();
    }
    closePanel() {
      if (!this.panel || !this.panel.classList.contains('is-open')) return;
      this.panel.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);
      window.HE.overlayChanged(-1);
      if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
    }
    onKey(e) {
      if (e.key === 'Escape') this.closePanel();
      else window.HE.trapFocus(this.panel.querySelector('.facets__panel'), e);
    }
  }
  if (!customElements.get('he-facets')) customElements.define('he-facets', HeFacets);
})();
